import { Api } from '@/munio/api/base'

class UserRelationship extends Api<{ user: number; company: number }> {
  constructor(userId: number, companyId: number) {
    super({
      user: userId,
      company: companyId,
    })
  }

  update(options: { relationshipId: number; departmentId?: number; reference?: string }) {
    return this.$post(this.$route('api.web.admin.user.company.update'), {
      relationship_id: options.relationshipId,
      department_id: options.departmentId,
      reference: options.reference,
    })
  }

  remove() {
    return this.$delete(this.$route('api.web.admin.user.company.remove'))
  }

  restore() {
    return this.$post(this.$route('api.web.admin.user.company.restore'))
  }

  employ() {
    return this.$post(this.$route('api.web.admin.user.company.employ'))
  }
}

export default UserRelationship
